<template>
    <header id="top-header" v-if="kiosk.id">
        <div class="offline-banner" v-if="isOffline">
            <i class="fad fa-exclamation-triangle"></i>
            Currently Offline - Limited Experience
        </div>
        <router-link to="/">Home</router-link>
        <span v-if="hasAreamap">&bull;</span>
        <router-link to="/area-map/" v-if="hasAreamap">
            Area Map
        </router-link>
        <span v-if="hasGalleries">&bull;</span>
        <router-link to="/galleries/" v-if="hasGalleries">
            Photos &amp; Videos
        </router-link>
        <span v-if="hasFloorplans">&bull;</span>
        <router-link to="/floorplans/" v-if="hasFloorplans">
            Floorplans
        </router-link>
        <span v-if="hasInventory">&bull;</span>
        <router-link to="/move-in-ready/" class="inventory" v-if="hasInventory">
            Move In Ready
        </router-link>
        <span v-if="hasLifestyles">&bull;</span>
        <router-link to="/lifestyles/" class="lifestyles" v-if="hasLifestyles">
            Lifestyles
        </router-link>
        <span v-if="hasKolter">&bull;</span>
        <router-link to="/about-kolter/" class="kolter" v-if="hasKolter">
            About Kolter
        </router-link>
        <span v-if="hasSiteplan">&bull;</span>
        <router-link to="/site-plan/" class="site-plan" v-if="hasSiteplan">
            Site Plan
        </router-link>
    </header>
</template>

<script>
    export default {
        props : ["kiosk"],
        computed:{
            hasAreamap() { return this.$store.getters.hasAreamap; },
            hasGalleries() { return this.$store.getters.hasGalleries; },
            hasFloorplans() { return this.$store.getters.hasFloorplans; },
            hasInventory() { return this.$store.getters.hasInventory; },
            hasLifestyles() { return this.$store.getters.hasLifestyles; },
            hasKolter() { return this.$store.getters.hasKolter; },
            hasSiteplan() { return this.$store.getters.hasSiteplan; },
            isOffline() { return this.$store.state.isOffline; }
        }
    };
</script>
